angular.module("vgresiduos").controller("ManagementInventoryReportCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "bi/relatorios/inventario-gerencial");
		};
	}
]);
